import { MyInfoType } from "DataTypes/Redux";
import { setMyInfo } from "../../Redux/User/Action";

const baseUrl = process.env.REACT_APP_BASE_URL || '';

export const FormateMyInfoData: (data: any) => MyInfoType = (data) => {
  return {
    id: data?.id,
    firstname: data?.firstName,
    lastname: data?.lastName,
    corporateOrg: data?.corporateOrg,
    userName: data?.userName,
    email: data?.userName || "",
    userType: data?.userType,
    profileImageUrl: data?.profilePicture
      ? `${baseUrl}${data?.profilePicture}`
      : "",
    phone: data?.phone || "",
    beProfessionalVerified: data?.beProfessionalVerified || false,
    mustChangePassword: data?.mustChangePassword || false,
  };
};

// Shared by every registration flow's auto-login-after-signup step (User/Corporate, NRI,
// Professional) — mirrors LoginPage's own finalizeLogin exactly (same localStorage keys the rest
// of the app reads: "token"/"x-nlp-userid", same Redux myInfo population). Registration used to
// hand-roll its own copy of this with the wrong keys ("user-token"/"userId", which nothing else
// reads) and no setMyInfo dispatch at all, so a freshly-registered user looked logged in for a
// moment but got bounced back to /login by ProtectedLayout on the very next protected route, or
// saw an empty profile because myInfo was never populated. Caller still does its own navigate()
// afterward — this only handles the storage/Redux side effects.
export const finalizeAutoLogin = (data: any, dispatch: any) => {
  const myInfoData = FormateMyInfoData(data);
  dispatch(setMyInfo(myInfoData));
  localStorage.setItem("token", data?.token);
  if (data?.refreshToken) {
    localStorage.setItem("refreshToken", data?.refreshToken);
  } else {
    localStorage.removeItem("refreshToken");
  }
  localStorage.setItem("x-nlp-userid", String(myInfoData?.id ?? ""));
};
